import React, {useEffect, useRef, useState} from 'react'
import {Tooltip} from 'react-tooltip'
import {getPiecePot, getProvenancePiece} from '../../../../components/requests'
import {ModeleTypePiecePOT} from '../../../../components/Models'
import {Pagination} from '../../../../components/Pagination'
import {DateInput} from '../../../../components/inputs/DateInput'
import {
  formatTypePiecePourDemande,
  shouldDisplayFonctionnalite,
} from '../../../../components/helpers'
import {useFormik} from 'formik'
import moment from 'moment'
import {toast} from 'react-toastify'
import {useAuth} from '../../../modules/auth'
import {Link} from 'react-router-dom'
import ModalPOT from '../../demande/Components/Televendeur/ModalPOT'
import {Modal} from 'bootstrap'

const PiecesPotsListPage = () => {
  const [spinner, setSpinner] = useState(false)
  const [data, setData] = useState<Array<ModeleTypePiecePOT>>([])
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(1)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [isSearch, setIsSearch] = useState(false)
  const [searchPage, setSearchPage] = useState<any>('')
  const [dateDebut, setDateDebut] = useState('')
  const [dateFin, setDateFin] = useState('')
  const [activateSearch, setActivateSearch] = useState<boolean>(false)
  const [selectedPOT, setSelectedPOT] = useState<any>(null)
  const isFirstLoad = useRef(true)
  const [provenances, setProvenances] = useState<any>([])
  const {currentUser} = useAuth()
  let userCanTraiterTouteDemande = shouldDisplayFonctionnalite(currentUser, 'TRAITER TOUTE DEMANDE')

  const statutColors: Record<string, string> = {
    A_PROPO: 'badge-light-dark',
    PROPO: 'badge-light-info',
    ACCEP: 'badge-light-primary',
    REFUS: 'badge badge-light-danger',
    BLOQU: 'badge-light-warning',
    CANCE: 'badge-light',
  }

  const statutLabels = {
    A_PROPO: 'À proposer',
    PROPO: 'Proposée',
    ASSIG: 'Assignée',
    ACCEP: 'Acceptée',
    REFUS: 'Refusée',
    CLOTP: 'Clôturée positive',
    CLOTN: 'Clôturée négative',
    BLOQU: 'Acceptée bloquée',
    CANCE: 'Annulée',
    ECHEC: 'Acceptée échec'
  }

  const getStatusPOT = (piecePot) => {
    let status = 'PROPO'
    if (!piecePot?.isProposed) status = 'A_PROPO'
    else if (piecePot?.isAccepted) status = 'ACCEP'
    else if (piecePot?.isRefused) status = 'REFUS'
    else if (piecePot?.isAcceptedBlocked) status = 'BLOQU'
    else if (piecePot?.dateAnnulation !== null) status = 'CANCE'
    else if (piecePot?.dateEchec !== null) status = 'ECHEC'
    return status
  }

  const getPiecePotData = () => {
    setSpinner(true)
    getPiecePot(isSearch ? currentPage : 1, searchPage, dateDebut, dateFin)
      .then((piecePotRequest) => {
        setNombreDePages(piecePotRequest?.pages)
        setTotalPages(piecePotRequest?.total)
        setCurrentPage(piecePotRequest?.page)
        if (piecePotRequest?.data !== undefined) {
          setData(piecePotRequest?.data?.map((piecePot) => ({
            ...piecePot[0],
            status: getStatusPOT(piecePot)
          })))
          setSpinner(false)
        }
      })
      .catch((e) => {
        setSpinner(false)
      })
  }

  const getAllProvenancePiece = () => {
    getProvenancePiece().then((res) => {
      if (res.status === 200 && res.data) {
        const transformedData = res.data.map((item) => ({
          value: item.id,
          label: item.libelle,
        }))
        setProvenances([...transformedData])
      } else {
        console.error('Erreur lors de la récupération des données')
      }
    })
  }

  const dateIntervalSearch = () => {
    if (activateSearch) {
      getPiecePotData()
    }
  }

  const showToastPOT = () => {
    toast.success("Pièce d'occasion taxable modifié avec succès.", {
      hideProgressBar: true,
      autoClose: 2000,
    })
  }

  const formik = useFormik({
    initialValues: {allSearch: '', dateDebut: '', dateFin: ''},
    onSubmit: (values, {setSubmitting}) => {
      setIsSearch(true)
      setDateDebut(values.dateDebut)
      setDateFin(values.dateFin)
    },
  })

  useEffect(() => {
    // Desactivé la recherche si les deux dates sont vides et l'activé si l'une d'elle a une valeur
    if (dateDebut === '' && dateFin === '' && searchPage === '') {
      setActivateSearch(false)
      setIsSearch(false)
      if (currentPage !== 1) {
        setCurrentPage(1)
      } else {
        getPiecePotData()
      }
    } else if (searchPage.length > 0) {
      setActivateSearch(true)
    } else if (dateDebut !== '' || dateFin !== '') {
      setActivateSearch(true)
      // Affiché une toast si dateFin est inférieur à dateDebut ou si dateFin n'a pas de valeur
      if (dateDebut !== null && dateFin !== null && dateFin < dateDebut) {
        if (dateFin !== '') {
          toast.warning('Veuillez saisir une date de début antérieure à la date de fin.')
          setActivateSearch(false)
        }
      }
    } else {
      setActivateSearch(false)
    }
  }, [dateDebut, dateFin, searchPage])

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false
      return
    }
    getPiecePotData()
  }, [currentPage])

  // Pour obtenir la liste des provenances
  useEffect(() => {
    getAllProvenancePiece()
  }, []);

  return (
    <>
      {/* begin::Row  */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className='col-lg-12 col-sm-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-8'>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold fs-3 mb-1'>Pièces d’Occasion Taxables</span>
              </h3>
            </div>
            {shouldDisplayFonctionnalite(currentUser, 'VOIR POT') && (
              <>
                {/* debut champs recherche */}
                <form
                  className='card-header border-0 pt-5 pb-5 gap-2'
                  id='searchForm'
                  onSubmit={formik.handleSubmit}
                >
                  <div className='col-lg-2 col-sm-12'>
                    <DateInput
                      fieldName='dateDebut'
                      inputClassName='form-control'
                      value={dateDebut}
                      setter={setDateDebut}
                      formik={formik}
                      placeholder='Date début'
                      customHeight={true}
                    />
                  </div>
                  <div className='col-lg-2 col-sm-12'>
                    <DateInput
                      fieldName='dateFin'
                      inputClassName='form-control'
                      value={dateFin}
                      setter={setDateFin}
                      formik={formik}
                      placeholder='Date fin'
                      customHeight={true}
                    />
                  </div>
                  <div className='col-lg-3 col-sm-12'>
                    <div className='d-flex'>
                      <input
                        type='text'
                        className='form-control h-45px'
                        defaultValue={searchPage}
                        name='allSearch'
                        placeholder='Rechercher...'
                        onChange={(e) => setSearchPage(e.target.value)}
                      />
                      <button
                        type='submit'
                        className={`btn border-0 input-group-append h-45px ${
                          activateSearch ? 'btn-primary cursor-pointer' : 'btn-light disabled'
                        }`}
                        onClick={() => {
                          activateSearch && dateIntervalSearch()
                        }}
                      >
                        <i className='fas fa-search text-secondary fs-1'></i>
                      </button>
                    </div>
                  </div>
                </form>
                {/* fin champs recherche */}
                {/* end::Header */}
                <>
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                          <tr className='fw-bold text-muted'>
                            <th className='min-w-150px'>Code</th>
                            <th className='min-w-140px'>Nom</th>
                            <th className='min-w-150px'>NE</th>
                            <th className='min-w-150px'>N° demande client</th>
                            <th className='min-w-100px'>Statut</th>
                            <th className='min-w-150px'>Type Pièce</th>
                            <th className='min-w-140px'>Fournisseur</th>
                            <th className='min-w-140px'>Prix d'achat TTC</th>
                            <th className='min-w-50px'>Prix de vente TTC</th>
                            <th className='min-w-140px'>Créateur</th>
                            <th className='min-w-140px'>Date création</th>
                            <th className='min-w-40px text-end'>Actions</th>
                          </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {spinner ? (
                            <tr>
                              <td colSpan={12} className='p-4 text-center h-500px'>
                                <span className='spinner-border spinner-border-sm align-middle ms-2 w-30px h-30px'></span>
                              </td>
                            </tr>
                          ) : data.length ? (
                            data.map((typePiecePot) => {
                              return (
                                <>
                                  <tr
                                    key={typePiecePot.id}
                                    className='cursor-pointer'
                                    onClick={() => {
                                      setSelectedPOT(typePiecePot);
                                      const modalElement = document.getElementById('modalPOT');
                                      if (modalElement) {
                                        const modal = new Modal(modalElement);
                                        modal.show();
                                      }
                                    }}
                                  >
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {typePiecePot?.code}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {typePiecePot?.nomPiece}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {typePiecePot?.NE}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {typePiecePot?.demande?.id}
                                      </p>
                                    </td>
                                    <td>
                                      <span className={`badge ${statutColors[typePiecePot?.status ?? ''] || 'badge-light'} my-1`}>
                                        {statutLabels[typePiecePot?.status ?? ''] || 'Statut inconnu'}
                                      </span>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {typePiecePot.typePieceRef !== undefined &&
                                        typePiecePot.typePieceRef !== null &&
                                        typePiecePot.typePieceRef?.id !== undefined
                                          ? formatTypePiecePourDemande(typePiecePot?.typePieceRef)
                                          : ''}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {typePiecePot?.fournisseur}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {typePiecePot?.prixAchatTTC}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {typePiecePot?.prixVenteTTC}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {typePiecePot?.creerPar?.nom}{' '}
                                        {typePiecePot?.creerPar?.prenom}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {moment(typePiecePot?.dateCreation).format('DD/MM/YYYY')}
                                      </p>
                                    </td>
                                    <td>
                                      <div className='d-flex justify-content-end flex-shrink-0 gap-3'>
                                        {(() => {
                                          let userCanTraiterDemande =
                                            (shouldDisplayFonctionnalite(
                                              currentUser,
                                              'TRAITER DEMANDE'
                                            ) &&
                                              (typePiecePot?.demande?.utilisateurAssigne?.id ===
                                                currentUser?.id ||
                                                typePiecePot?.demande?.clientDemandeEtape?.code ==
                                                  'NOUVE')) ??
                                            false

                                          if (userCanTraiterTouteDemande || userCanTraiterDemande) {
                                            return (
                                              <Link
                                                to={`/demandes/${typePiecePot?.demande?.client?.id}/traitement/${typePiecePot?.demande?.id}`}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                }}
                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                state={{
                                                  redirectToClientDemande: true,
                                                  isFromPOT: true
                                                }}
                                              >
                                                <i className='bi bi-eye fs-2'></i>
                                              </Link>
                                            )
                                          }
                                        })()}
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              )
                            })
                          ) : (
                              <tr>
                                <td colSpan={12} className='text-center'>
                                  Aucun résultat trouvé
                                </td>
                              </tr>
                          )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                    {/* end::Table container */}

                    {/* begin::pagination*/}
                    <Pagination
                        totalPages={totalPages}
                        nombreDePages={nombreDePages}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        locationState={0}
                    />
                    {/* end::pagination*/}

                    {/* begin::Modal POT */}
                    <ModalPOT
                      piece={selectedPOT}
                      isEdit={true}
                      showToastPOT={showToastPOT}
                      listPot={data}
                      setListPot={setData}
                      provenances={provenances}
                    />
                    {/* end::Modal POT */}

                    {/*Affichage du tooltip*/}
                    <Tooltip id='tooltip'/>
                  </div>
                </>
              </>
            )}
          </div>
        </div>
        {/* end::Col  */}
      </div>
      {/* end::Row  */}
    </>
  )
}

export {PiecesPotsListPage}
